import _extends from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["items", "onClick", "setError", "setLoading", "children"];
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useCallback, useContext } from "react";
import { emitAddToCart, getSourcePlatform } from "@catchoftheday/analytics";
import { Button } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { MutationType, useToast } from "../../hooks";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var AddItemsToCartButton = function AddItemsToCartButton(_ref) {
  var items = _ref.items,
      onClick = _ref.onClick,
      setError = _ref.setError,
      setLoading = _ref.setLoading,
      children = _ref.children,
      buttonProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data;

  var addItemsToCart = useToast({
    mutationType: MutationType.ADD_ITEMS_TO_CART,
    setError: setError,
    setLoading: setLoading
  });
  var toastValues = items.map(function (_ref2) {
    var imageUrl = _ref2.imageUrl,
        title = _ref2.title,
        offerId = _ref2.offerId;
    return {
      imageUrl: imageUrl,
      title: title,
      offerId: offerId
    };
  });
  var itemsToCartValues = items.map(function (_ref3) {
    var offerId = _ref3.offerId,
        quantity = _ref3.quantity;
    return {
      offerId: offerId,
      quantity: quantity,
      sourcePlatform: getSourcePlatform()
    };
  });
  var onAddToCart = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$addItemsToCart, status;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return addItemsToCart(toastValues, {
              itemsToBeAdded: {
                items: itemsToCartValues
              }
            });

          case 2:
            _yield$addItemsToCart = _context.sent;
            status = _yield$addItemsToCart.status;

            if (status !== "ServerError") {
              items.forEach(function (item) {
                emitAddToCart({
                  customer_id: customer === null || customer === void 0 ? void 0 : customer.id,
                  success: Array.isArray(status) && status.find(function (error) {
                    return error.offerId == item.offerId;
                  }) ? false : true,
                  source_id: item.sourceId,
                  source_type: item.sourceType,
                  source_position: item.sourcePosition,
                  offer_id: item.offerId,
                  event_id: item.eventId || 1
                });
              });
            }

            if (typeof onClick === "function") {
              onClick();
            }

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [addItemsToCart, toastValues, itemsToCartValues, items, customer === null || customer === void 0 ? void 0 : customer.id]);
  return ___EmotionJSX(Button, _extends({
    onClick: onAddToCart,
    "aria-label": "Add to cart"
  }, buttonProps), children);
};